'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');

const RadioListContainer = ({ children, className, testId })=>{
    return jsxRuntime.jsx("div", {
        className: tailwindMerge.twMerge('flex w-full flex-col gap-3', className),
        "data-testid": testId,
        children: children
    });
};

module.exports = RadioListContainer;
